import bootstrap from "shared/bootstrap";
import baseManifest from "modules/base";
import portalManifest from "./portal-manifest";
import envLoader from "shared/env-loader";
import relationprofile from "modules/relationprofile";
import customLocalisation from "./i18n";
import manuals from "modules/manuals";
import feedback from "modules/feedback";
import contact from "modules/contact";
import projectsupload from "customer-modules/hca/projectsupload";

const vuetify = {
  theme: {
    primary: "#8c0e68",
    secondary: "#19171c",
    accent: "#6e6254",
    error: "#f44336",
    warning: "#ffeb3b",
    info: "#2196f3",
    success: "#4caf50",
  },
};

bootstrap({
  title: "Mijn HealthCare Auditing",
  vuetify,
  customLocalisation,
  modules: [
    baseManifest,
    portalManifest,
    relationprofile,
    projectsupload,
    manuals,
    feedback,
    contact,
  ],
  axios: {
    baseURL: envLoader("API_URL", "/"),
    withCredentials: true,
  },
  customToolbar: [
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    () => import("../../modules/feedback/components/ToolbarFeedbackAction.vue"),
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    () => import("../../modules/contact/components/GlobalContactButton.vue"),
  ],
});
